import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-items-message',
  templateUrl: './no-items-messge.component.html'
})
export class NoItemsMessageComponent implements OnInit {

  constructor(
    ){
  }

  ngOnInit() {
  }
}


// WEBPACK FOOTER //
// ./src/app/components/partials/no-items-message/no-items-messge.component.ts